import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Logsheet } from 'src/app/models/logsheet.model';
import { ActiveForm } from 'src/app/models/active-form.model';
import { FormStatistics } from 'src/app/models/form-statistics.model';
import { TempGroup } from 'src/app/models/tempgroup.model';
import { formTemplateTempGroup } from 'src/app/models/formtemplatetempgroup.model';
@Injectable({
  providedIn: 'root'
})
export class LogsheetService {
  baseUrl: string = environment.apiUrl
  constructor(private http: HttpClient) { }

  retrieveLogsheetByUnit(id: number): Observable<Logsheet[]> {
    const queryParams = new URLSearchParams();
    queryParams.set('isConsole', 'true');
    return this.http.get<Logsheet[]>(this.baseUrl + '/logsheet/unit/' + id + `?${queryParams.toString()}`)
  }

  loadLogSheets(pageNumber: number, pageSize: number, logSheetType: string, logSheetStatus: string, startDate: string, endDate: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/logsheet/logs?pageNumber=${pageNumber}&pageSize=${pageSize}&logSheetType=${logSheetType}&logSheetStatus=${logSheetStatus}&startDate=${startDate}&endDate=${endDate}`)
  }

  retrieveLogsheetByUnitPaginated(id: number, pageNumber: number, pageSize: number): Observable<Logsheet[]> {
    const queryParams = new URLSearchParams();
    queryParams.set('isConsole', 'true');
    return this.http.get<Logsheet[]>(`${this.baseUrl}/logsheet/unit/${id}/${pageNumber}/${pageSize}?${queryParams.toString()}`)
  }

  addLogSheet(addLogsheet: Logsheet): Observable<Logsheet> {
    return this.http.post<Logsheet>(this.baseUrl + '/logsheet', addLogsheet)
  }

  scheduleLogSheet(id: number, scheduleLogsheet: Logsheet): Observable<Logsheet> {
    return this.http.post<Logsheet>(this.baseUrl + '/logsheet/schedule/' + id, scheduleLogsheet)
  }

  assignLogSheet(id: string, assignLogsheet: Logsheet): Observable<Logsheet> {
    return this.http.post<Logsheet>(this.baseUrl + '/logsheet/assign/' + id, assignLogsheet)
  }

  assignTempForm(id: string, request: any): Observable<Logsheet> {
    return this.http.post<Logsheet>(this.baseUrl + '/logsheet/assign/temp/' + id, request);
  }

  retrieveLogSheetById(id: string): Observable<Logsheet> {
    return this.http.get<Logsheet>(this.baseUrl + '/logsheet/' + id)
  }

  retrieveLogsheet(id: string): Observable<Logsheet> {
    return this.http.get<Logsheet>(this.baseUrl + '/logsheet/' + id)
  }

  retrieveLogsheetRelative(id: string): Observable<Logsheet> {
    return this.http.get<Logsheet>(this.baseUrl + '/logsheet/relative/' + id)
  }

  retrieveLogsheetWithConditions(id: string): Observable<Logsheet> {
    return this.http.get<Logsheet>(this.baseUrl + '/logsheet/with-conditions/' + id)
  }

  updateLogSheet(id: string, updateLogsheetRequest: Logsheet): Observable<Logsheet> {
    return this.http.patch<Logsheet>(this.baseUrl + '/logsheet/' + id, updateLogsheetRequest)
  }

  updateLogSheetStatus(id: string, statusUpdate: { status: string, currentUser?: string }): Observable<Logsheet> {
    return this.http.post<Logsheet>(this.baseUrl + '/logsheet/logs/' + id, statusUpdate)
  }

  deactivateLogSheet(id: number): Observable<Logsheet> {
    return this.http.patch<Logsheet>(this.baseUrl + '/logsheet/deactivate/' + id, {})
  }

  retrieveLogSheetByRelativeId(item: any): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/LogSheet/logs-console?templateId=' + item.id + '&pageNumber=' + item.pageNumber + '&pageSize=' + item.pageSize + '&startDate=' + item.startDate + '&endDate=' + item.endDate)
  }

  retrieveAnalytics(days: number, plantId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/logsheet/logs/analytics/${days}/${plantId}`)
  }

  retrieveActiveFormsForPlant(plantId: number): Observable<ActiveForm[]> {
    return this.http.get<ActiveForm[]>(`${this.baseUrl}/logsheet/active-forms/${plantId}`)
  }

  retrieveFormStatistics(templateId: number, days: number): Observable<FormStatistics> {
    return this.http.get<FormStatistics>(`${this.baseUrl}/logsheet/form-statistics/${templateId}/${days}`)
  }

  retrieveActualLogsheet(id: string): Observable<Logsheet> {
    return this.http.get<Logsheet>(this.baseUrl + '/logsheet/actual-logsheet/' + id)
  }

  retrieveLogSheetForPublicUser(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/auth/verify-public-user');
  }

  retrieveSelectedTempFormTemplate(id:number): Observable<formTemplateTempGroup[]> {
    return this.http.get<formTemplateTempGroup[]>(this.baseUrl + "/logsheet/temp-assignments/" + id);
  }

}

